const Adult = ({ color = "#FAFAFA", size = 20 }) => {
  return (
    <>
      <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <mask
          id='mask0_2102_54084'
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='24'
          height='24'
        >
          <rect width='24' height='24' fill='#D9D9D9' />
        </mask>
        <g mask='url(#mask0_2102_54084)'>
          <path
            d='M12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22ZM12 20C12.9333 20 13.8123 19.854 14.637 19.562C15.4623 19.2707 16.2167 18.8583 16.9 18.325L13.575 15H16.4L18.3 16.9C18.8333 16.2167 19.25 15.4623 19.55 14.637C19.85 13.8123 20 12.9333 20 12C20 9.78333 19.221 7.89567 17.663 6.337C16.1043 4.779 14.2167 4 12 4C11.0667 4 10.1877 4.15 9.363 4.45C8.53767 4.75 7.78333 5.16667 7.1 5.7L10.425 9H7.6L5.7 7.1C5.16667 7.78333 4.75 8.53767 4.45 9.363C4.15 10.1877 4 11.0667 4 12C4 14.2167 4.77933 16.1043 6.338 17.663C7.896 19.221 9.78333 20 12 20ZM5 14L6.5 12L5 10H6.5L7.25 11L8 10H9.5L8 12L9.5 14H8L7.25 13L6.5 14H5ZM9.75 14L11.25 12L9.75 10H11.25L12 11L12.75 10H14.25L12.75 12L14.25 14H12.75L12 13L11.25 14H9.75ZM14.5 14L16 12L14.5 10H16L16.75 11L17.5 10H19L17.5 12L19 14H17.5L16.75 13L16 14H14.5Z'
            fill={color}
          />
        </g>
      </svg>
    </>
  );
};

export default Adult;
